
export interface CreateSubscriptionSession200Response {
  /** 생성된 구독 주문번호 */
  orderId?: string;
  /** 리다이렉트 URL */
  redirectUrl?: string;
  /** 결제 페이지 URL */
  subscriptionUrl?: string;
  success?: boolean;
}
